import api from './axios';

const authApi = {
  sendOtp: (phone) =>
    api.post('/auth/send-otp', { phone }),

  verifyOtp: (phone, otp, device_name) =>
    api.post('/auth/verify-otp', { phone, otp, device_name }),

  oldLogin: (phone, password, device_name) =>
    api.post('/auth/old-login', { phone, password, device_name }),

  oldRegister: (fullname, phone, password, password_confirmation, isvendor) =>
    api.post('/auth/old-register', { fullname, phone, password, password_confirmation, isvendor }),

  logout: () =>
    api.post('/auth/logout'),

  me: () =>
    api.get('/auth/me'),

  refreshToken: (refresh_token) =>
    api.post('/auth/refresh-token', { refresh_token }),
};

export default authApi;
